import "./StorageImages.css";

const StorageImages = ({ storagePhotos, setDeletePhoto }) => {
  const handleSetDeletePhoto = (idx) => {
    setDeletePhoto(idx);
  };

  return (
    <div>
      <h4>Slike iz baze</h4>
      <div className="storageImagesContainer">
        {storagePhotos.map((photo, idx) => {
          const encodedImagePath = encodeURIComponent(photo);
          return (
            <div className="storagePhotoContainer" key={idx}>
              <img
                className="thumbnail"
                src={`https://api.meetmontenegro.me/images/${encodedImagePath}`}
                alt="small thumbnail"
              />
              <span
                className="removeBtn"
                onClick={() => handleSetDeletePhoto(idx)}
              >
                x
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StorageImages;
